// src/components/Loading.js
import React from 'react';
import { Spinner } from 'react-bootstrap'; // Import Spinner from React Bootstrap
import '../css/Loading.css'; // Import CSS file

const Loading = () => {
  
  return (
    // <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
    //   <Spinner animation="grow" role="status" style={{color:'#023e6f'}}>
    //     <span className="visually-hidden">Loading...</span>
    //   </Spinner>
    // </div>
<>
    <div class="loading">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
   
  </div>
    <h6 style={{color:'#3f7936'}}>Loading....</h6>
  </>
  );
};

export default Loading;
